import * as React from "react";
const PersonWithHouse = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94.5h94z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#3F3F3F", d: "M16.7 63.5c8.56 0 15.5-6.94 15.5-15.5s-6.94-15.5-15.5-15.5S1.2 39.44 1.2 48s6.94 15.5 15.5 15.5" }),
        React.createElement("path", { fill: "#ED0000", d: "M32.3 63.7H1V95h31.3z" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M95 32.3H32.3L63.7 1z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M63.7 32.3V95H95V32.3z" }),
        React.createElement("path", { fill: "#ED0000", d: "M32.3 32.3v31.4h31.4V32.3z" }))));
export default PersonWithHouse;
//# sourceMappingURL=PersonWithHouse.js.map